module.exports = __webpack_public_path__ + "static/media/dem_bur.2ec91343.png";